const SUPPORTED_SOCIAL_IDPS = ['facebook', 'google', 'linkedin', 'microsoft', 'apple'];
export default {
  SUPPORTED_SOCIAL_IDPS,
};



// WEBPACK FOOTER //
// ./src/util/IDP.js